if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(async response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const slideOutCart = new SlideOutCart();
          await slideOutCart.init();
          slideOutCart.openCart(true);
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add("hidden");
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.addEventListener("click", (e) => this.scrollToProductForm(e));
  }

  scrollToProductForm(e) {
    e.preventDefault();

    const href = this.getAttribute("href");
    const offsetTop = document.querySelector(href).offsetTop;
    const fixedHeaderHeight = document.querySelector('.header').offsetHeight;
    
    scroll({
      top: offsetTop - fixedHeaderHeight,
      behavior: "smooth"
    });
  }
}

customElements.define("mobile-add-to-cart", AddToCart);

class StockNotification extends HTMLElement {

  constructor() {
    super();
    this.api = this.getAttribute('data-company-id')
    this.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + this.api;
    this.src_stock = "https://a.klaviyo.com/media/js/onsite/onsite.js";
    this.btn = this.querySelector('#klaviyo-stock-btn');
    this.text = this.btn.innerHTML;

    this.init();
  }

  init() {
    const allScripts = document.querySelectorAll("script");
    const klaviyoScriptExists = [...allScripts].map(script =>
      script.src.includes("static.klaviyo.com/onsite/js/klaviyo.js?company_id"),
    );

    if (!klaviyoScriptExists.includes(true)) {
      this.loadScript(this.src, () => {
        this.loadScript(this.src_stock, () => {
          this.runScript();
        });
      });
    } else {
      this.loadScript(this.src_stock, () => {
        this.runScript();
      });
    }

  }

  runScript () {

    if (klaviyo.init) {
      this.backInStockScript();
    } else {
      setTimeout(() => this.loop(), 1000);
    }
  }

  loop () {
    this.runScript();
  }

  loadScript( url, callback ) {
    var script = document.createElement( "script" )
    script.type = "text/javascript";
    if(script.readyState) {  // only required for IE <9
      script.onreadystatechange = function() {
        if ( script.readyState === "loaded" || script.readyState === "complete" ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function() {
        callback();
      };
    }
  
    script.src = url;
    document.getElementsByTagName( "head" )[0].appendChild( script );
  }

  backInStockScript() {

    this.btn.innerHTML = "";

    //Copied from https://help.klaviyo.com/hc/en-us/articles/360001895651-How-to-Install-Back-in-Stock-for-Shopify
    klaviyo.init({
      account: this.api,
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
      trigger: {
        product_page_text: this.text,
        product_page_class: "btn",
        product_page_text_align: "center",
        product_page_margin: "0px",
        alternate_anchor: "klaviyo-stock-btn",
        replace_anchor: false
      },
      modal: {
      headline: "{product_name}",
      body_content: "Register to receive a notification when this item comes back in stock.",
      email_field_label: "Email",
      button_label: "Notify me when available",
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content: '',
      additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#002640",
      button_text_color: "#fff",
      button_background_color: "#002640",
      close_button_color: "#002640",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500"
      }
    });
  }
}

customElements.define("out-of-stock-notification", StockNotification);

class VariantLinksSwatch extends HTMLElement {
  constructor(){
    super();
    this.$swatches = this.querySelectorAll('.label-swatch');

    this.init();
  }

  init() {
    this.applyColorPattern();
  }

  applyColorPattern() {
    this.$swatches.forEach($swatch => {
      const name = $swatch.getAttribute('data-link-name');
      if(window.swatches) {
        const data = window.swatches.find(obj => obj.title === name);
        const color = data?.color;
        const pattern = data?.pattern;

        if (pattern) {
          $swatch.innerHTML = `<span style="background-image: url(${pattern});"></span>`;
          return;
        }

        $swatch.innerHTML = `<span style="background-color: ${color};"></span>`;
      }
    });
  }
}

customElements.define("variant-quick-links", VariantLinksSwatch);